import React from "react";
import Button from "../../../../components/Button";
import Container from "@material-ui/core/Container";
import Loading from "../../../../components/Loading";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { AdapterLink } from "../../../../components/Adopter";
import { useQuery } from "react-query";
import { mutateErrors } from "../../../../utils";
import Error from "../../../../components/Error";
import PageHeader from "../../../../components/PageHeader";
import { Routes } from "../../../../constants/routes";
import Grid from "@material-ui/core/Grid";
import useServiceQueries from "../../hooks/useServiceQueries";
import ServiceListItem from "../../components/ServiceListItem";
import { QUERY_KEYS } from "../../../../constants";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
  },
}));

export default function ListPage() {
  const classes = useStyles();

  const { services } = QUERY_KEYS;

  const { fetchAll } = useServiceQueries();
  const { isLoading, isFetching, isError, error, refetch, data } =
    useQuery<any>(services, fetchAll);

  if (isLoading || isFetching) {
    return <Loading />;
  }

  if (isError) {
    const { message } = mutateErrors(error);
    return <Error text={message} />;
  }

  return (
    <>
      <Container maxWidth="lg">
        <PageHeader
          title={"Services"}
          subtitle={"Here are listed services"}
          endAdornment={
            <Button
              color={"success"}
              variant={"contained"}
              component={AdapterLink}
              to={`/0/${Routes.SERVICES_ADMIN}/create`}
            >
              Add
            </Button>
          }
        />
      </Container>

      <Container maxWidth="lg" className={classes.container}>
        <Grid container spacing={2}>
          {data &&
            data.data.map((service: any, index) => (
              <ServiceListItem
                onDelete={refetch}
                index={index}
                service={service}
                key={`ServiceListItem_${index}`}
              />
            ))}
        </Grid>
      </Container>
    </>
  );
}
